module.exports = __webpack_public_path__ + "static/title2.a6a3fb9cf8d1fb7a59d98560653d969f.png";